
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import eventBus from '../plugins/eventBus'
import Filters from '@/components/Filters.vue'
import InfiniteLoading from 'vue-infinite-loading'
import { addToCartSuccess } from '@/plugins/popups'
import Pagination from '@/components/Pagination.vue'
import { ItemModel } from '@/store/models/ItemModel'
import { ItemsStore } from '@/store/stores/ItemsStore'
import FiltersHeader from '@/components/FiltersHeader.vue'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { getParameter } from '@/plugins/globals'

Vue.use(InfiniteLoading)

@Component({
  components: { Filters, Pagination, FiltersHeader },
})
export default class Item extends Vue {
  @Prop({ required: false }) value!: any
  selectedCategoryId: number = -1
  searchValue: string = ''
  currentPage: number = 1
  pageSize: number = 30
  sectorId: any
  sorting: string = ''
  envConfigurations: any = envConfiguration
  items: ItemsStore = ItemsStore.getInstance()

  payload = {
    params: {
      price_range: [1, 9999],
    },
  }

  public get payloadData() {
    this.payload.params.price_range[0] = this.value.minValue
    this.payload.params.price_range[1] = this.value.maxValue
    // this.loadItemsData()
    return this.payload
  }

  addToCart(item: ItemModel) {
    if (item.outOfStock) {
      return
    }
    const quantity = 1
    eventBus.$emit('cart:item-added', item, quantity)
    addToCartSuccess()
  }

  addToFavorites(item: ItemModel) {
    item.addToFavorites()
  }

  deleteFavorite(item: ItemModel) {
    item.deleteFavorite()
    item.isFavorite = false
  }

  viewModal(item: any) {
    eventBus.$emit('item_modal', item)
  }

  formatName(name: string) {
    if (name === null) return 'Nuk Ka Emër'
    if (name.split('').length > 50) {
      return `${name.split(' ').slice(0, 8).join(' ')}...`
    }
    return name
  }

  onPageChange(page) {
    this.currentPage = page
    this.loadItemsData()
  }

  get totalPages(): number {
    return parseInt(String(Math.ceil(this.items.total / this.pageSize)))
  }

  sortValue(value) {
    this.sorting = value.target.value
    this.loadItemsData()
  }

  prepareQuery(): string {
    let sector = ''
    if (this.sectorId) {
      sector = `&sector_id=${this.sectorId}`
    }
    let valueToSearch: string = this.searchValue.toLowerCase()
    return `?qs=${valueToSearch}${sector}&page-size=${this.pageSize}&page=${this.currentPage}&group_id=${
      this.selectedCategoryId
    }&ordering=${this.sorting.substr(this.sorting.indexOf(' '), this.sorting.length)}&sort_by=${this.sorting.substr(
      0,
      this.sorting.indexOf(' ')
    )}&sale_price=100`
  }

  @Watch('$route')
  onRouteParamChange() {
    this.selectedCategoryId = parseInt(this.$route.params.id)
    this.loadItemsData()
  }

  mounted() {
    if (this.$route.params.id) {
      this.selectedCategoryId = parseInt(this.$route.params.id)
    }

    eventBus.$on('sector', (sector) => {
      this.sectorId = sector
      this.loadItemsData()
    })

    this.loadItemsData()

    eventBus.$on('search:changed-value', (valueToSearch: string) => {
      this.searchValue = valueToSearch
      this.loadItemsData()
    })
    eventBus.$on('categories:selected', (categoryIdToSearch: number) => {
      this.selectedCategoryId = categoryIdToSearch
      this.loadItemsData()
    })
  }

  loadItemsData() {
    this.items.loadData(this.prepareQuery(), this.payload)
  }
}
